import { API, Auth } from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import { Table, TableCell, TableHead, TableRow } from '@aws-amplify/ui-react';
import EntitySerachReportRow from './EntitySerachReportsRow';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
// import '../../report.css'

const EntitySerachReportTable = (props) => {
  const search_id = props.search_id
  const new_report = props.new_report
  const [entities, setEntities] = useState([])
  const [projectid, setprojectid] = useState([])
  const [categories, setCategories] = useState([])
  const [isBusy, setIsBusy] = useState(false);
  const [reportname, setReportname] = useState('');
  const [errorMessage, setErrorMessage] = useState('');


  //Function to fetch from our backend and update customers array
  const getsearches = async () => {
    setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }
    console.log('new_report', new_report)
    let api_params = "/getsavedsearch" + `?reportid=${search_id}`
    if (new_report == 'true')
    api_params += "&create=true"

    API.get("DocumentSearchUser", api_params, requestInfo)
      .then(response => {
        setIsBusy(false);
        console.log( response)
        let newEntities = response.items
        setprojectid(response.project_id)
        setEntities(newEntities)
        setCategories(response.categories.join(', '))
        setReportname(response.report_name)
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error)
      })
  };
  useEffect(() => { getsearches() }, [])

  
  const handleDelete = async (entity) => {
    setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }
    API.get("DocumentSearchUser", `/deletereportitem?reportid=${search_id}&entityid=${entity.id}`, requestInfo)
      .then(response => {
        setIsBusy(false);
        let index = entities.indexOf(entity)
        if (index >= 0){
          let newEntities = [...entities];
          newEntities.splice(index, 1)
          setEntities(newEntities)
        }
        else 
          console.log('index not found')
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error)
      })
  };
  const handleSelect = (entity) => {
    console.log('selected ' + entity.id)
    // API.get('DocumentSearchUser', '/deleteproject' + `?userid=${entity.user_id}&projectid=${entity.project_id}`)
    //    .then(response => {
    //      //console.log(response)
    //      getProjects();

    //    })
    //    .catch(error => {
    //      console.log(error)
    //    })
  };

  const renameReport = async (name) => {
    setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }
    console.log(name, name.input)
    API.get('DocumentSearchUser', '/namereport' + `?reportid=${search_id}&name=${name.reportname}`, requestInfo)
      .then(response => {
        setIsBusy(false);
        setErrorMessage('');
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error)
        if (error.response.status == 406) {
          setErrorMessage('A report with the same name already exists!');
        }
      })
  };

  return (
    <>
      <Row>
        <Col>
          <br />
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Entity Search Report</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row>
        <Col>
          <h1 style={{ textAlign: 'center'}}>Entity Search Report</h1>
        </Col>
      </Row>
      <Row>
        <Col style={{ textAlign: 'initial'}}>
        <InputGroup className="mb-3">
                <InputGroup.Text>Report Name:</InputGroup.Text>
                <FormControl
                  placeholder="enter new report name"
                  aria-label=""
                  aria-describedby="basic-addon2"
                  value={reportname} onChange={(e) => setReportname(e.target.value)}
                />
                <Button variant="outline-secondary" id="button-addon2" onClick={() => renameReport({ reportname })}>
                  {/* <PlusLg /> */}Rename
                </Button>
              </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col>

          {errorMessage && (
            <Alert key="danger" variant="danger">
              {errorMessage}
            </Alert>
          )}</Col>
      </Row>
      <Row>
        <Col style={{ textAlign: 'initial'}}>
          <b>Entities: </b> {categories}
        </Col>
      </Row>
      <Row>
        <Col>
          {isBusy &&
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          }
        </Col>
      </Row>
      <Row>
        <Col>
          <Table className='table table-striped'>
            <TableHead className='thead-dark' style={{ textAlign: 'center'}}>
              <TableRow>
                <TableCell><strong>#</strong></TableCell>
                <TableCell><strong>Document Name</strong></TableCell>
                <TableCell><strong>Entity Category</strong></TableCell>
                <TableCell><strong>Entity </strong></TableCell>
                <TableCell><strong>Page</strong></TableCell>
                <TableCell><strong>Text</strong></TableCell>
                <TableCell><strong>Confidence</strong></TableCell>
                <TableCell><strong>      </strong></TableCell>

              </TableRow>
            </TableHead>
            <tbody>
              {
                entities.map((thisEntity, index) => {
                  return (
                    <EntitySerachReportRow key={thisEntity.id} projectid={projectid} index={index} onDelete={handleDelete} entity={thisEntity} onSelect={handleSelect} />
                  )
                })
              }
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  )
}


export default EntitySerachReportTable;